export default __webpack_public_path__ + "static/media/weight_female.2b90a5e6.png";